<template>
  <div>
    <v-card flat>
      <v-toolbar flat color="grey lighten-3">
        <v-toolbar-title v-if="deptMoves.length"> Υπόλοιπο: {{ deptMoves[deptMoves.length - 1].Balance |fixed }}€</v-toolbar-title>
        <v-spacer/>
        <v-toolbar-items>

          <filters-modal v-if="isMobile" module-name="PartnerDeptMovesHandler">
            <template v-slot:before-filters>
              <div style="margin-right: 10px">
                <label style="font-size: 0.7em" for="dateFrom"> Από </label>
                <br>
                <input @change="getData()" style="border-bottom: grey 1px solid; padding-top: 0"
                       id="dateFrom" type="date"
                       v-model="options.FromDate">
              </div>
              <div>
                <label style="font-size: 0.7em" for="date"> Eώς </label>
                <br>
                <input @change="getData()" style="border-bottom: grey 1px solid; padding-top: 0"
                       id="date"
                       type="date"
                       v-model="options.ToDate">
              </div>
            </template>
          </filters-modal>

          <v-row justify="center" align="center" class="pr-5" v-if="!isMobile">
            <div style="margin-right: 10px">
              <label style="font-size: 0.7em" for="dateFrom"> Από </label>
              <br>
              <input @change="getData()" style="border-bottom: grey 1px solid; padding-top: 0"
                     id="dateFrom" type="date"
                     v-model="options.FromDate">
            </div>
            <div>
              <label style="font-size: 0.7em" for="date"> Eώς </label>
              <br>
              <input @change="getData()" style="border-bottom: grey 1px solid; padding-top: 0" id="date"
                     type="date"
                     v-model="options.ToDate">
            </div>
          </v-row>
        </v-toolbar-items>
        <print-pdf-button id-to-print="table" :page-title="partnerName+'_'+options.FromDate+'_'+options.ToDate" ></print-pdf-button>
      </v-toolbar>
      <v-data-table v-show="!isMobile" id="table" :items="data" :headers="headers" hide-default-footer disable-pagination
                    fixed-header :height=" isMobile?'auto':'65vh'"
                    no-results-text="Δεν βρέθηκαν οικονομικές εκκρεμότητες"
                    :mobile-breakpoint="0"

      >
        <template v-slot:item.icon="{item}">
          <div>
            <v-icon :color="colors[item.transactionType()]" v-if="item.transactionType() === 'Μετρητοίς'">
              mdi-swap-horizontal
            </v-icon>
            <v-icon :color="colors[item.transactionType()]" v-else-if="item.transactionType() === 'Χρέωση'">
              mdi-arrow-left
            </v-icon>
            <v-icon :color="colors[item.transactionType()]" v-else>
              mdi-arrow-right
            </v-icon>
            <span :style="'color:'+colors[item.transactionType()]"> {{ item.transactionType() }} </span>
          </div>
        </template>
        <template v-slot:item.Pistosi="{item}">
          {{ item.Pistosi | fixed }}€
        </template>
        <template v-slot:item.Xreosi="{item}">
          {{ item.Xreosi | fixed }}€
        </template>
        <template v-slot:item.Balance="{item}">
          <strong> {{ item.Balance | fixed }}€ </strong>
        </template>
        <template v-slot:item.NumberPar="{item}">
          <div v-if="item.StandBy && !item.isEkmetaforas">
            <v-chip> Σε αναμονή</v-chip>
          </div>
          <div v-else>{{ item.NumberPar }}</div>
        </template>
      </v-data-table>
      <v-list v-if="isMobile">
        <v-list-item v-for="d in data">
          <v-sheet :height="50" class="mr-3" width="3" :color="colors[d.transactionType()]">
          </v-sheet>
          <v-list-item-content>
            <v-list-item-title><strong> {{ d.Hmerom }} </strong></v-list-item-title>
            <v-list-item-title>
              <v-icon :color="colors[d.transactionType()]" v-if="d.transactionType() === 'Μετρητοίς'">
                mdi-swap-horizontal
              </v-icon>
              <v-icon :color="colors[d.transactionType()]" v-else-if="d.transactionType() === 'Χρέωση'">
                mdi-arrow-left
              </v-icon>
              <v-icon :color="colors[d.transactionType()]" v-else>
                mdi-arrow-right
              </v-icon>
              {{ d.InvoiceDescr }} <span v-if="d.StandBy && !d.isEkmetaforas">
                        <v-chip small> Σε αναμονή</v-chip>
                      </span>
              <span v-else>{{ d.NumberPar }}</span>{{ d.NumberPar }} {{ d.transactionType() }}
            </v-list-item-title>

            <v-list-item-subtitle>
              {{ d.BranchAddress }}
            </v-list-item-subtitle>
            <p class="text--grey pb-1" style="font-size: 0.85em">
              {{ d.Description }}
            </p>
          </v-list-item-content>
          <v-list-item-action>
            <v-list-item-action-text> Ποσό</v-list-item-action-text>
            <span v-if="d.Xreosi">{{ d.Xreosi | fixed }} €</span>
            <span v-else-if="d.Pistosi">{{ d.Pistosi | fixed }}</span>
            <v-list-item-action-text> Υπόλοιπο:</v-list-item-action-text>
            <div class="text-center"
                 style=" font-weight: bold; font-size: 1em;">
              {{ d.Balance | fixed }} €
            </div>
          </v-list-item-action>

        </v-list-item>
      </v-list>
    </v-card>
  </div>

</template>

<script>
import store from "../../../store";
import {saveAs} from 'file-saver';
import XLSX from 'xlsx';
import dataGridHandler from "../../../wl-datagrid-handler/dataGridHandler";
import moment from 'moment';
import {mapActions, mapGetters, mapMutations} from "vuex";
import FiltersModal from "../../../wl-datagrid-handler/FiltersModal";
import PrintPdfButton from "@/components/PrintPdfButton";

export default {
  name: "PartnerDeptMoves",
  components: {PrintPdfButton, FiltersModal},
  data: () => ({
    colors: {
      'Μετρητοίς': "grey",
      "Πίστωση": "green",
      "Χρέωση": "red"
    },
    options: {
      FromDate: moment(new Date('1/1/' + new Date().getFullYear())).format('YYYY-MM-DD'),
      ToDate: moment(Date.now()).format('YYYY-MM-DD'),
    },
    headers: [
      {
        value: "icon",
        width: "130"
      },
      {
        text: 'Hμ/νια ',
        value: 'Hmerom',
        filterable: true,
        width: "100"
      },
      {
        text: '#Παρ.',
        value: 'NumberPar',
        filterable: false,
        sortable: false,
        width: "70"
      },
      {
        text: 'Τύπος',
        value: 'InvoiceDescr',
        filterable: false,
        sortable: false,
        width: "70"
      },
      {
        text: 'Περιγραφή',
        value: 'Description',
        filterable: false,
        sortable: false,

      },
      {
        text: 'Κτήριο',
        value: 'BranchAddress',
        filterable: true,
        width: "200"
      }, {
        text: 'Χρέωση',
        value: 'Xreosi',
        filterable: true,
        align: 'end',
        width: "120"
      },
      {
        text: 'Πίστωση',
        value: 'Pistosi',
        filterable: true,
        width: "120",
        align: 'end',
      },
      {
        text: 'Υπόλοιπο',
        value: 'Balance',
        filterable: true,
        align: 'end',
        width: "120"
      },
    ]
  }),
  props: {partnerId: Number, partnerName: String},
  created() {
    this.getData();
  },
  watch: {
    partnerId() {
      this.getData();
    },
  },
  beforeCreate() {
    store.unregisterModule('PartnerDeptMovesHandler');
    store.registerModule('PartnerDeptMovesHandler', dataGridHandler);
  },
  beforeDestroy() {
    store.unregisterModule('PartnerDeptMovesHandler');
  },
  computed: {
    ...mapGetters([
      "deptMoves",
      "isMobile",
    ]),
    ...mapGetters('PartnerDeptMovesHandler', [
      "data",
      "modal"
    ]),
  },
  methods: {
    getData() {
      this.showLoading();
      this.setLoadingMessage("Φόρτωση αναλυτικών κινήσεων");
      this.getDeptMoveDetails({
        Partner_ID: this.partnerId,
        ...this.options
      }).then(deptMoves => {
        this.setData(deptMoves);
        this.hideLoading();
        if (this.modal)
          this.toggleModal();
      })
    },
    ...mapMutations([
      "showLoading",
      "setLoadingMessage",
      "hideLoading",
    ]),
    ...mapMutations('PartnerDeptMovesHandler', [
      "toggleModal",
      "setData",
      "createFilters",
    ]),
    ...mapActions([
      "exportToExcel",
      "getDeptMoveDetails"
    ])

  }
}
</script>

<style scoped>

</style>
